import { useSession } from '@/api/auth';
import { useAccountProviders } from '@/api/hooks';
import { UserAvatar } from '@/components/UserAvatar';

const PROVIDER_LABELS: Record<string, string> = {
  credential: 'Email & Password',
  microsoft: 'Microsoft 365',
};

export default function AccountInfoPage() {
  const { data: session } = useSession();
  const accounts = useAccountProviders(true);

  const userName =
    (session?.user as { name?: string } | undefined)?.name ?? session?.user?.email ?? '';
  const email = session?.user?.email ?? '';
  const providers = accounts.data?.providers ?? [];

  const signInMethod = accounts.isLoading
    ? 'Loading…'
    : providers.length === 0
    ? '—'
    : providers.map((p) => PROVIDER_LABELS[p] ?? p).join(', ');

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-lg font-semibold text-foreground">Account info</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Your personal account details.
        </p>
      </div>

      <div className="overflow-hidden rounded-xl border border-border bg-card shadow-sm">
        {/* Profile header */}
        <div className="flex items-center gap-4 border-b border-border bg-muted/30 px-6 py-5">
          <UserAvatar name={userName} size={52} />
          <div className="min-w-0">
            <div className="truncate text-[15px] font-semibold text-foreground">{userName}</div>
            <div className="truncate text-[13px] text-muted-foreground">{email}</div>
          </div>
        </div>

        {/* Field rows */}
        <div className="divide-y divide-border">
          <FieldRow label="Full Name" value={userName} />
          <FieldRow label="Email Address" value={email} />
          <FieldRow label="Sign-in Method" value={signInMethod} />
        </div>
      </div>
    </div>
  );
}

function FieldRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-center gap-6 px-6 py-3.5">
      <span className="w-36 shrink-0 text-[11px] font-medium uppercase tracking-wider text-muted-foreground">
        {label}
      </span>
      <span className="text-[13.5px] text-foreground">{value}</span>
    </div>
  );
}
